import React from "react";
import HomeNavBar2 from "../Components/HomeNavBar/HomeNavBar2";
import AboutUs from "../Components/AboutUs/AboutUs";

const AboutUsPage = () => {
    return (
        <div>
            <HomeNavBar2 />
            <AboutUs />
        </div>
    );
}

export default AboutUsPage;